const STOP = new Set("a an the i my me to do how can where what is are it of on in for and or with you your we does get".split(" "));
const stem = (w) => w.replace(/(ing|ed|es|s)$/, "");
const words = (t) => t.toLowerCase().replace(/[’']/g, "").replace(/[^a-z0-9 ]+/g, " ").split(/\s+/).filter((w) => w && !STOP.has(w)).map(stem);

// Score each topic by keyword phrases and shared words; best first.
export function rank(text, topics) {
  const flat = ` ${words(text).join(" ")} `;
  const mine = new Set(flat.trim().split(" "));
  return topics.map((t) => {
    let s = 0;
    for (const k of t.keys) {
      const kw = words(k);
      if (kw.length > 1 && flat.includes(` ${kw.join(" ")} `)) s += 3 * kw.length;
      else s += kw.filter((w) => mine.has(w)).length;
    }
    s += words(t.q).filter((w) => mine.has(w)).length * 0.5;
    return { t, s };
  }).filter((x) => x.s > 0).sort((a, b) => b.s - a.s);
}
